import axiosInstance from '@/core/api'
import type { components } from '@/schema'

export type AdminAssetsResponse = components['schemas']['AdminAssetsResponse']
export type UpdateAdminAssetsDto = components['schemas']['UpdateAdminAssetsDto']

class AdminAssetsService {
	static async getAdminAssets(): Promise<AdminAssetsResponse> {
		const { data } = await axiosInstance.get<AdminAssetsResponse>(
			'/admin/admin-assets',
		)
		return data
	}

	static async updateAdminAssets(
		payload: UpdateAdminAssetsDto,
	): Promise<AdminAssetsResponse> {
		const { data } = await axiosInstance.patch<AdminAssetsResponse>(
			'/admin/admin-assets',
			payload,
		)
		return data
	}
}

export default AdminAssetsService
